import React from 'react';
import { useSelector } from 'react-redux';

import { getCountries } from 'modules/countries/selectors';

import Flag from './Flag';

const Label = ({ countryCode }) => {
  const countries = useSelector(getCountries);
  const { prefix } = countries[countryCode] ?? {};

  return (
    <span className="d-flex align-items-center">
      <Flag countryCode={countryCode} className="w-4 mr-2" />
      <span>+{prefix}</span>
    </span>
  );
};

export default Label;
